export const computeInsetWithScrollbar = () => {
  try {
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    (outer.style as any).msOverflowStyle = "scrollbar";
    document.body.appendChild(outer);

    const inner = document.createElement("div");
    outer.appendChild(inner);
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    outer.parentNode?.removeChild(outer);

    return scrollbarWidth;
  } catch (error) {
    console.error(
      "HelpWidget - Failed to compute inset with scrollbar:",
      error,
    );
    return 0;
  }
};
